import { mdlIdCodeNamePair } from "../models/domain/IdCodeNamePair";
import { mdlBaseRequest } from "../models/service-models/common/BaseRequest";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlHotelCategoryListResponse } from "../models/service-models/hotel/HotelCategoryListResponse";
import { mdlHotelListRequest } from "../models/service-models/hotel/HotelListRequest";
import { mdlHotelListResponse } from "../models/service-models/hotel/HotelListResponse";
import { GetResponse } from "../utils/ApiClient";

namespace HotelService {
    export async function List(
        pRequest: mdlHotelListRequest
    ): Promise<mdlServiceResponse<mdlHotelListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelListResponse>>(
            "hotel/list",
            pRequest
        );
    }
    export async function CategoryList(
        pRequest: mdlBaseRequest
    ): Promise<mdlServiceResponse<mdlHotelCategoryListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelCategoryListResponse>>(
            "hotel/category-list",
            pRequest
        );
    }
}
export { HotelService };
